import "./css/AboutUs.css";
import "./css/Complaints.css";
import React from "react";
import { FaBook, FaDownload } from "react-icons/fa";

const OtherDocuments = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header testing-header">
        <div className="overlay">
          <h1 className="page-title">Other Documents</h1>
          <p className="subtitle">
            Access additional MBS publications and strategic documents below.
          </p>
        </div>
      </section>

      {/* === Other Documents Section === */}
      <section className="how-it-works">
        
        <div className="steps-container">
          {/* Document 1 */}
          <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>MBS Standards Work Programme</h3>
            <p>
              Take a look at the MBS Standards Work Programme. Click the link below to download.
            </p>
            <a
              href="/files/2024-STANDARDS-WORK-PROGRAMME-ISSUE-35-2.pdf"
              download
              className="download-btn"
              style={{color: "#ff6600" }}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>

          {/* Document 2 */}
          <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>National Standardization Strategy</h3>
            <p>
              Take a look at the National Standardization Strategy. Click the link below to download.
            </p>
            <a
              href="/files/MALAWI-NATIONAL-STANDARDISATION-STRATEGY-FOR-2021-2023.pdf"
              download
              className="download-btn"
              style={{color: "#ff6600" }}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>

          {/* Document 3 */}
          <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>Strategic Plan 2023–28</h3>
            <p>
              Take a look at the Strategic Plan 2023–28. Click the link below to download.
            </p>
            <a
              href="/files/MBS-2023-2028-Strategic-Plan (1).pdf"
              download
              className="download-btn"
              style={{color: "#ff6600" }}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>

          {/* Document 4 */}
          <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>Service Charter</h3>
            <p>
              Take a look at the MBS Service Charter. Click the link below to download.
            </p>
            <a
              href="/files/SERVICE-CHARTER-ISO-DOC.pdf"
              download
              className="download-btn"
              style={{color: "#ff6600" }}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>

           {/* Document 1 */}
           <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>MBS-CID-P100-F01 CERTIFICATION AGREEMENT.</h3>
            {/* <p>
              Take a look at the MBS Service Charter. Click the link below to download.
            </p> */}
            <a
              href="/files/STD/MBS-CID-P100-F01 CERTIFICATION AGREEMENT.pdf"
              download
              className="download-btn"
              style={{color: "#ff6600" }}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>

           {/* Document 2 */}
           <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>MBS-CID-P800-F01 APPLICATION FOR LICENCE  FORM</h3>
            {/* <p>
              Take a look at the MBS Service Charter. Click the link below to download.
            </p> */}
            <a
              href="/files/STD/MBS-CID-P800-F01 APPLICATION FOR LICENCE  FORM.pdf"
              download
              className="download-btn"
              style={{color: "#ff6600" }}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>


           {/* Document 3 */}
           <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>MBS-CID-P800-F02 INITIAL QUESTIONNAIRE FOR FACTORY ASSESSMENT</h3>
            {/* <p>
              Take a look at the MBS Service Charter. Click the link below to download.
            </p> */}
            <a
              href="/files/STD/MBS-CID-P800-F02 INITIAL QUESTIONNAIRE FOR FACTORY ASSESSMENT.pdf"
              download
              className="download-btn"
              style={{color: "#ff6600" }}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>


           {/* Document 4 */}
           <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>MBS-CID-P800-GL01 GUIDELINES FOR ENQUIRY ABOUT PRODUCT CERTIFICATION</h3>
            {/* <p>
              Take a look at the MBS Service Charter. Click the link below to download.
            </p> */}
            <a
              href="/files/STD/MBS-CID-P800-GL01 GUIDELINES FOR ENQUIRY ABOUT PRODUCT CERTIFICATION.pdf"
              download
              className="download-btn"
              style={{color: "#ff6600" }}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>

           {/* Document 5 */}
           <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>MBS-CID-P800-GL02 GUIDELINES FOR APPLICANTS  FOR PRODUCT CERTIFICATION</h3>
            {/* <p>
              Take a look at the MBS Service Charter. Click the link below to download.
            </p> */}
            <a
              href="/files/STD/MBS-CID-P800-GL02 GUIDELINES FOR APPLICANTS  FOR PRODUCT CERTIFICATION.pdf"
              download
              className="download-btn"
              style={{color: "#ff6600" }}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>

           {/* Document 6 */}
           <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>MBS-CID-P820 PROCEDURE FOR GRANT OF CERTIFICATION</h3>
            {/* <p>
              Take a look at the MBS Service Charter. Click the link below to download.
            </p> */}
            <a
              href="/files/STD/MBS-CID-P820 PROCEDURE FOR GRANT OF CERTIFICATION.pdf"
              download
              className="download-btn"
              style={{color: "#ff6600" }}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>

           {/* Document 7 */}
           <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>MBS-CID-P830 PROCEDURE FOR SURVEILLANCE</h3>
            {/* <p>
              Take a look at the MBS Service Charter. Click the link below to download.
            </p> */}
            <a
              href="/files/STD/MBS-CID-P830 PROCEDURE FOR SURVEILLANCE.pdf"
              download
              className="download-btn"
              style={{color: "#ff6600" }}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>

           {/* Document 8 */}
           <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>MBS-CID-P920 PROCEDURE FOR TERMINATION REDUCTION SUSPENSION OR WITHDRAWAL OF CERTIFICATION</h3>
            {/* <p>
              Take a look at the MBS Service Charter. Click the link below to download.
            </p> */}
            <a
              href="/files/STD/MBS-CID-P920 PROCEDURE FOR TERMINATION REDUCTION SUSPENSION OR WITHDRAWAL OF CERTIFICATION.pdf"
              download
              className="download-btn"
              style={{color: "#ff6600" }}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>


           {/* Document 9 */}
           <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>MBS-CID-P940 PROCEDURE FOR HANDLING COMPLAINTS AND APPEALS</h3>
            {/* <p>
              Take a look at the MBS Service Charter. Click the link below to download.
            </p> */}
            <a
              href="/files/STD/MBS-CID-P940 PROCEDURE FOR HANDLING COMPLAINTS AND APPEALS.pdf"
              download
              className="download-btn"
              style={{color: "#ff6600" }}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>


           {/* Document 10 */}
           <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>MBS-CID-PSC001 Certification Scheme for Bottled Drinking Water</h3>
            {/* <p>
              Take a look at the MBS Service Charter. Click the link below to download.
            </p> */}
            <a
              href="/files/STD/MBS-CID-PSC001 Certification Scheme for Bottled Drinking Water.pdf"
              download
              className="download-btn"
              style={{color: "#ff6600" }}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>


           {/* Document 11 */}
           <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>MBS-CID-PSC002 Certification Scheme for Honey</h3>
            {/* <p>
              Take a look at the MBS Service Charter. Click the link below to download.
            </p> */}
            <a
              href="/files/STD/MBS-CID-PSC002 Certification Scheme for Honey.pdf"
              download
              className="download-btn"
              style={{color: "#ff6600" }}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>

           {/* Document 12 */}
           <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>MBS-CID-PSC003 Certification Scheme for Macadamia</h3>
            {/* <p>
              Take a look at the MBS Service Charter. Click the link below to download.
            </p> */}
            <a
              href="/files/STD/MBS-CID-PSC003 Certification Scheme for Macadamia.pdf"
              download
              className="download-btn"
              style={{color: "#ff6600" }}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>


           {/* Document 13 */}
           <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>MBS-CID-PSC004 Certification Scheme for Groundnuts</h3>
            {/* <p>
              Take a look at the MBS Service Charter. Click the link below to download.
            </p> */}
            <a
              href="/files/STD/MBS-CID-PSC004 Certification Scheme for Groundnuts.pdf"
              download
              className="download-btn"
              style={{color: "#ff6600" }}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>


           {/* Document 14 */}
           <div className="step-card">
            <div className="icon-circle">
              <FaBook className="info-icon" />
            </div>
            <h3>MBS-CID-PSC005 Certification Scheme for Roasted coffee bean and Roasted ground coffee</h3>
            {/* <p>
              Take a look at the MBS Service Charter. Click the link below to download.
            </p> */}
            <a
              href="/files/STD/MBS-CID-PSC005 Certification Scheme for Roasted coffee bean and Roasted ground coffee.pdf"
              download
              className="download-btn"
              style={{color: "#ff6600" }}
            >
              <FaDownload className="download-icon" /> Download
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OtherDocuments;
